export default __webpack_public_path__ + "static/media/book-nav-icon2-completed.1ce13985.svg";